import { Flex, Typography } from 'antd'
import React from 'react'

type Props = {
  content: string
}

export const Indication: React.FC<Props> = ({ content }) => {
  if (!content) {
    return <></>
  }

  return (
    <Flex className="w-full">
      <Typography.Text type="secondary">{content}</Typography.Text>
    </Flex>
  )
}
